<!--<span class="spacer"></span>-->
<ng-container *ngFor="let step of steps; let last = last; let i = index">
    <app-pseudo-step-header [label]="step.label" [state]="step.state" [index]="i" [active]="i === this._activeStep" [disabled]="step.disabled" (click)="onStepClick(i)"></app-pseudo-step-header>
    <mat-divider *ngIf="!last"></mat-divider>
</ng-container>
<!--<span class="spacer"></span>-->
